import {
  dbui_v1_TransformRequest,
  dbuiV1TransformOptions,
} from '@antimatterhq/asl-api-ts-v1';
import { useQuery } from '@antimatterhq/ui/hooks/queries/useQuery';
import { useWorkspace } from '@/contexts/WorkspaceContext';
import { defaultOptions } from '@/utils/query';
import { useWarehouseLocation } from '@/contexts/WarehouseLocationContext';

export const useGetTransform = (
  data: Omit<dbui_v1_TransformRequest, 'warehouse'>,
) => {
  const { workspace } = useWorkspace();
  const { selectedWarehouse } = useWarehouseLocation();

  return useQuery({
    ...dbuiV1TransformOptions({
      ...defaultOptions(),
      path: { workspace },
      body: { ...data },
      query: { warehouse: selectedWarehouse!.id },
    }),
    enabled:
      !!workspace &&
      !!selectedWarehouse &&
      (!!data.autoloaderInput || !!data.input),
  });
};
